import React, { useState } from 'react';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    school: '',
    role: '',
    message: '',
    interest: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // Create FormData object for Netlify Forms
      const form = e.target;
      const formDataToSend = new FormData(form);
      
      // Send to Netlify Forms endpoint
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formDataToSend).toString(),
      });
      
      if (response.ok) {
        setSubmitted(true);
        setFormData({
          name: '',
          email: '',
          school: '',
          role: '',
          message: '',
          interest: ''
        });
        // Reset success message after 5 seconds
        setTimeout(() => setSubmitted(false), 5000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
      alert('There was an error submitting your form. Please try again or email us directly at 12monthstoflourish@gmail.com');
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <div className="hero-content text-center">
            <div className="logo-container">
              <img 
                src="https://static.wixstatic.com/media/1d90b3_588e219d6cc2449d84256529ea18235d~mv2.png" 
                alt="Digital Flourishing for Young Minds" 
                className="page-logo"
              />
            </div>
            <h1>Contact Us</h1>
            <p className="hero-description">
              Ready to transform your school's digital culture? Get in touch with our team to 
              discuss how Digital Flourishing for Young Minds can benefit your educational institution.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="section section-white">
        <div className="container">
          <div className="contact-container">
            <div className="contact-info">
              <h2>Get Started Today</h2>
              <p>
                We're here to help you create a healthier digital culture in your school. 
                Fill out the form and we'll be in touch within 24 hours to discuss your needs.
              </p>
              
              <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-icon">📧</div>
                  <div className="method-content">
                    <h4>Email Us</h4>
                    <p>12monthstoflourish@gmail.com</p>
                  </div>
                </div>
                <div className="contact-method">
                  <div className="method-icon">📞</div>
                  <div className="method-content">
                    <h4>Call Us</h4>
                    <p>+44 (0) 20 1234 5678</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-form">
              {submitted && (
                <div className="success-message">
                  <h3>✓ Thank You!</h3>
                  <p>Your message has been sent successfully. We'll contact you within 24 hours.</p>
                </div>
              )}
              <form name="contact" method="POST" data-netlify="true" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="school">School/Institution Name *</label>
                    <input
                      type="text"
                      id="school"
                      name="school"
                      value={formData.school}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="role">Your Role *</label>
                    <select
                      id="role"
                      name="role"
                      value={formData.role}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select your role</option>
                      <option value="headteacher">Headteacher/Principal</option>
                      <option value="deputy">Deputy Head</option>
                      <option value="teacher">Teacher</option>
                      <option value="coordinator">Digital Coordinator</option>
                      <option value="governor">School Governor</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="interest">Primary Interest *</label>
                  <select
                    id="interest"
                    name="interest"
                    value={formData.interest}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">What are you most interested in?</option>
                    <option value="teacher-training">Teacher Professional Development</option>
                    <option value="parent-workshops">Parent Workshop Series</option>
                    <option value="pilot-program">Pilot Program Application</option>
                    <option value="full-implementation">Full Program Implementation</option>
                    <option value="consultation">Free Consultation</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Tell us about your school's digital challenges and goals</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="5"
                    placeholder="Share any specific challenges you're facing with digital wellness..."
                  ></textarea>
                </div>

                <input type="hidden" name="form-name" value="contact" />
                <button type="submit" className="btn btn-primary submit-btn" disabled={submitted}>
                  {submitted ? 'Message Sent!' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
